const btnClearFilterManagementService = {
  Typography: 'Borrar todos'
};

export default btnClearFilterManagementService;
